import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';

import { formValidate } from '@eb/eds-utils';
import { MailChunky } from '@eb/eds-iconography';
import { ProgressIndicator } from '@eb/eds-progress-indicator';

import EmailField from '../EmailField';
import FormSubmitButton from '../FormSubmitButton';
import PageHeader from '../PageHeader';

import ConnectedAuthNotification from '../../connectedComponents/AuthNotification';

import { emailValidate as validate } from '../utils';
import { PASSWORDLESS_FORM } from '../../constants';
import { Button } from '@eb/eds-button';
import './PasswordlessForm.scss';

const PasswordlessForm = ({
    autoFocus,
    handleSubmit,
    isSubmitOngoing,
    dataTestId,
    onClickBackToLogin,
}) => {
    let body = (
        <form
            onSubmit={handleSubmit}
            noValidate="novalidate"
            data-testid={`${dataTestId}-component`}
        >
            <div className="eds-l-pad-bot-6">
                <EmailField autoFocus={autoFocus} />
            </div>

            <div className="eds-l-pad-bot-8 eds-align--center">
                <FormSubmitButton
                    submitDisabled={isSubmitOngoing}
                    dataTestid={`${dataTestId}-submit`}
                    buttonCTA={gettext('Send login link')}
                    style="link"
                    __containerClassName="passwordless-form__button--grey"
                />
            </div>
            <div className="eds-text-color--ui-800 eds-text-weight--heavy  eds-align--center eds-l-mar-top-5">
                <Button
                    onClick={onClickBackToLogin}
                    type="button"
                    style="anchor"
                    data-testid="passwordless-back-login"
                >
                    {gettext('Back to Log In')}
                </Button>
            </div>
        </form>
    );
    let headerText = gettext('Where should we send your login link?');
    let subtitleText = gettext(
        'For your security, the link expires in 2 hours.',
    );
    if (isSubmitOngoing) {
        body = (
            <div
                className="eds-l-pad-bot-4 eds-align--center"
                data-testid={`${dataTestId}-loading`}
            >
                <ProgressIndicator
                    size="large-chunky"
                    shape="circular"
                    style="gradient"
                />
            </div>
        );
        headerText = gettext('We’re sending your login link');
        subtitleText = '';
    }

    return (
        <div className="forgot-password-form eds-fx--fade-in eds-fx--delay-2">
            <PageHeader
                headerText={headerText}
                iconType={<MailChunky />}
                subtitleText={subtitleText}
                iconColor="ui-700"
                bottomSpacing="eds-l-mar-bot-4"
            />

            <ConnectedAuthNotification />

            {body}
        </div>
    );
};

PasswordlessForm.propTypes = {
    handleSubmit: PropTypes.func,
    autoFocus: PropTypes.bool,
    isSubmitOngoing: PropTypes.bool,
    dataTestid: PropTypes.string,

    /* Props Provided Via ReduxForm */
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitting: PropTypes.bool,
};

export default formValidate({
    validate,
    form: PASSWORDLESS_FORM,
    touchOnBlur: false,
})(PasswordlessForm);
